// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========================================================================
   Template — 글로벌 템플릿 (Figma 2001:12597)
   ======================================================================== */

/* 카테고리 탭 + 템플릿 공유 버튼 */
.tpl-list__topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-top: 24px;
}

.tpl-list__tabs {
  display: flex;
  align-items: center;
}

.tpl-list__tab {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 10px;
  background: transparent;
  border: 0;
  border-bottom: 2px solid transparent;
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  color: var(--fg-text-basic);
  cursor: pointer;
  white-space: nowrap;
  transition: var(--transition-fast);
}

.tpl-list__tab:hover {
  color: var(--fg-side-hover);
}

.tpl-list__tab--active {
  border-bottom-color: var(--fg-text-basic);
}

.tpl-list__tab-count {
  font-size: 13px;
  font-weight: 400;
  color: var(--fg-text-gray);
}

.tpl-list__share-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 42px;
  padding: 6px 12px;
  background: var(--fg-button);
  border: 0;
  border-radius: 12px;
  color: #fff;
  font-family: inherit;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: var(--transition-fast);
}

.tpl-list__share-btn:hover {
  background: var(--fg-button-hover);
}

/* 폴더 필터 (Figma 858:18362 — 공유 종목 체크박스 스타일) */
.tpl-list__folders {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin: 12px 0 4px;
}

.tpl-list__folders-label {
  font-size: 12px;
  font-weight: 600;
  color: var(--fg-text-basic);
  white-space: nowrap;
  margin-right: 8px;
}

.tpl-list__folders-items {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.tpl-list__folder-cb {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 0;
  background: transparent;
  border: 0;
  font-family: inherit;
  cursor: pointer;
}

.tpl-list__folder-cb-box {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 4px;
  background: var(--fg-checkbox-off);
  color: #fff;
  flex-shrink: 0;
  transition: var(--transition-fast);
}

.tpl-list__folder-cb-box--on {
  background: var(--fg-side-hover);
}

.tpl-list__folder-cb-label {
  font-size: 12px;
  font-weight: 400;
  color: var(--fg-text-basic);
  white-space: nowrap;
}

.tpl-list__folder-cb-count {
  font-size: 12px;
  font-weight: 400;
  color: var(--fg-text-gray);
}

/* 필터 행 (Figma 2001:12639) */
.tpl-list__filter-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-top: 12px;
  padding: 9px 0;
}

.tpl-list__filter-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.tpl-list__filter-icon {
  display: inline-flex;
  width: 24px;
  height: 24px;
  color: var(--fg-text-basic);
  margin-right: 8px;
}

.tpl-list__filter-cb {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.tpl-list__filter-cb-label {
  font-size: 14px;
  color: var(--fg-text-basic);
  white-space: nowrap;
}

.tpl-list__filter-cb-count {
  font-size: 14px;
  color: var(--fg-text-gray);
  margin-left: 4px;
}

.tpl-list__cb {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border: 1px solid var(--fg-line);
  border-radius: 4px;
  background: #fff;
  color: #fff;
  flex-shrink: 0;
  transition: var(--transition-fast);
}

.tpl-list__cb--on {
  background: var(--fg-button);
  border-color: var(--fg-button);
}

.tpl-list__filter-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* 카드 그리드 (Figma 2001:12661 — 4열, gap 20px) */
.tpl-list__grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 20px;
  width: 100%;
  margin-top: 12px;
}

/* 단일 템플릿 카드 (Figma 2001:12662 — List - Box full 369x198) */
.tpl-list__card {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 20px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 12px;
  min-height: 198px;
  transition: var(--transition-fast);
}

.tpl-list__card:hover {
  border-color: var(--fg-button);
  box-shadow: var(--shadow-sm);
}

.tpl-list__card-head {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
}

.tpl-list__card-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  align-self: flex-start;
  padding: 6px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 400;
  color: var(--fg-text-basic);
  white-space: nowrap;
  line-height: 1;
}

.tpl-list__card-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  line-height: 28px;
  color: var(--fg-text-basic);
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.tpl-list__card-meta {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  color: var(--fg-text-gray);
}

.tpl-list__card-user {
  display: inline-flex;
  align-items: center;
  gap: 2px;
}

.tpl-list__card-meta-divider {
  display: inline-block;
  width: 1px;
  height: 14px;
  background: var(--fg-line);
}

.tpl-list__card-desc {
  flex: 1 1;
  margin: 0;
  font-size: 15px;
  font-weight: 400;
  line-height: 24px;
  color: var(--fg-text-basic);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.tpl-list__card-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0;
  margin-top: auto;
}

.tpl-list__card-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 2px;
  background: transparent;
  border: 0;
  border-radius: 8px;
  color: var(--fg-text-gray);
  cursor: pointer;
  transition: var(--transition-fast);
}

.tpl-list__card-icon-btn:hover {
  background: var(--fg-bg-card);
  color: var(--fg-text-basic);
}

.tpl-list__card-icon-btn--liked {
  color: #ff1500;
}

.tpl-list__card-icon-btn--liked:hover {
  color: #ff1500;
  background: rgba(255, 21, 0, 0.08);
}

.tpl-list__card-icon-btn--danger {
  color: #ea5440;
}

.tpl-list__card-icon-btn--danger:hover {
  background: rgba(234, 84, 64, 0.08);
}

.tpl-list__card-likes {
  font-size: 12px;
  color: #ff1500;
  margin-right: 4px;
}

/* 반응형: 1280px 이하에서 3열 */
@media (max-width: 1280px) {
  .tpl-list__grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

/* ──────────────── 카드 클릭 가능 / 선택 상태 ──────────────── */
.tpl-list__card {
  cursor: pointer;
  transition: border-color 160ms ease, box-shadow 160ms ease, transform 120ms ease;
}

.tpl-list__card:hover {
  border-color: var(--primary-300, #c7b8ff);
  box-shadow: var(--shadow-sm, 0 1px 3px rgba(0, 0, 0, 0.06));
}

.tpl-list__card--selected {
  border-color: var(--primary-500, #7c5cff);
  box-shadow: 0 0 0 2px var(--primary-100, #ece6ff) inset;
}

.tpl-list__card:focus-visible {
  outline: 2px solid var(--primary-500, #7c5cff);
  outline-offset: 2px;
}

/* ──────────────── 우측 슬라이드 미리보기 패널 (Figma 2047:12694) ──────────────── */
.tpl-preview__backdrop {
  position: fixed;
  inset: 0;
  background: rgba(15, 17, 28, 0.32);
  opacity: 0;
  pointer-events: none;
  transition: opacity 220ms ease;
  z-index: 90;
}

.tpl-preview__backdrop--open {
  opacity: 1;
  pointer-events: auto;
}

.tpl-preview {
  position: fixed;
  top: 0;
  right: 0;
  height: 100vh;
  width: 760px;
  max-width: 96vw;
  background: var(--fg-bg-toolbox);
  border-top-right-radius: 16px;
  box-shadow: -4px 0 7px rgba(0, 0, 0, 0.2);
  transform: translateX(100%);
  transition: transform 280ms cubic-bezier(0.22, 0.61, 0.36, 1);
  display: flex;
  flex-direction: column;
  font-family: var(--font-sans);
  z-index: 100;
  overflow: hidden;
}

.tpl-preview--open {
  transform: translateX(0);
}

.tpl-preview__header {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 20px 20px 0;
  flex-shrink: 0;
}

.tpl-preview__title {
  flex: 1 1;
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  line-height: 28px;
  color: #ffffff;
  word-break: break-word;
}

.tpl-preview__copy {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 32px;
  padding: 5px 7px 7px;
  background: var(--fg-button);
  border: 0;
  border-radius: 4px;
  color: #ffffff;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
  cursor: pointer;
  transition: background 120ms ease;
  flex-shrink: 0;
}

.tpl-preview__copy:hover:not(:disabled) {
  background: var(--fg-button-hover);
}

.tpl-preview__copy:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.tpl-preview__close {
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  padding: 2px;
  background: transparent;
  border: 0;
  border-radius: 8px;
  color: #ffffff;
  cursor: pointer;
  transition: background 120ms ease;
  flex-shrink: 0;
}

.tpl-preview__close:hover {
  background: rgba(255, 255, 255, 0.10);
}

.tpl-preview__body {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.tpl-preview__tags-row {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.tpl-preview__tag {
  display: inline-flex;
  align-items: center;
  padding: 6px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 400;
  color: var(--fg-text-basic);
  white-space: nowrap;
  line-height: 1;
}

.tpl-preview__meta {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: var(--fg-text-menu);
  margin-top: -8px;
}

.tpl-preview__meta-divider {
  width: 1px;
  height: 12px;
  background: rgba(255, 255, 255, 0.20);
}

.tpl-preview__desc-box {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  border: 1px solid var(--fg-line);
  border-radius: 8px;
  background: transparent;
}

.tpl-preview__desc-box-title {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  color: #ffffff;
}

.tpl-preview__desc-box-text {
  margin: 0;
  font-size: 15px;
  line-height: 24px;
  color: #ffffff;
  white-space: pre-wrap;
  word-break: break-word;
}

.tpl-preview__section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.tpl-preview__section-title {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: #ffffff;
}

.tpl-preview__section-text {
  margin: 0;
  padding: 8px 12px;
  background: var(--fg-bg-toolbox-elev);
  border: 1px solid var(--fg-line);
  border-radius: 8px;
  font-size: 16px;
  line-height: 26px;
  color: #ffffff;
  white-space: pre-wrap;
  word-break: break-word;
}

.tpl-preview__section-pre {
  margin: 0;
  padding: 8px 12px;
  background: var(--fg-bg-toolbox-elev);
  border: 1px solid var(--fg-line);
  border-radius: 8px;
  font-family: inherit;
  font-size: 16px;
  line-height: 26px;
  color: #ffffff;
  white-space: pre-wrap;
  word-break: break-word;
  max-height: 320px;
  overflow-y: auto;
}

.tpl-preview__section-pre--code {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 13px;
  line-height: 1.6;
  max-height: 480px;
}

.tpl-preview__bullets {
  list-style: disc inside;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 15px;
  line-height: 24px;
  color: #ffffff;
}

.tpl-preview__chips {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.tpl-preview__chip {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  background: var(--fg-bg-toolbox-elev);
  border: 1px solid var(--fg-line);
  border-radius: 9999px;
  font-size: 12px;
  color: #ffffff;
}

.tpl-preview__meta-list {
  list-style: none;
  margin: 0;
  padding: 12px 16px;
  background: var(--fg-bg-toolbox-elev);
  border: 1px solid var(--fg-line);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 14px;
}

.tpl-preview__meta-list li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.tpl-preview__meta-list li span {
  color: var(--fg-text-menu);
}

.tpl-preview__meta-list li b {
  font-weight: 600;
  color: #ffffff;
}

.tpl-preview__loading {
  margin: 0;
  font-size: 13px;
  color: var(--fg-text-menu);
  text-align: center;
}

.tpl-preview__node-list {
  list-style: none;
  margin: 0;
  padding: 12px;
  background: var(--fg-bg-toolbox-elev);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.tpl-preview__node-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 10px 12px;
  background: var(--fg-bg-toolbox);
  border: 1px solid var(--fg-line);
  border-radius: 8px;
}

.tpl-preview__node-info {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.tpl-preview__node-name {
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
  word-break: break-word;
}

.tpl-preview__node-desc {
  font-size: 12px;
  color: var(--fg-text-menu);
  line-height: 1.5;
  word-break: break-word;
}

/* 다크 패널 내부 스크롤바 (선택적 스타일링) */
.tpl-preview__body::-webkit-scrollbar,
.tpl-preview__section-pre::-webkit-scrollbar {
  width: 8px;
}

.tpl-preview__body::-webkit-scrollbar-thumb,
.tpl-preview__section-pre::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.15);
  border-radius: 4px;
}

.tpl-preview__body::-webkit-scrollbar-thumb:hover,
.tpl-preview__section-pre::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.25);
}

/* ========================================================================
   ShareTemplateModal — 내 템플릿을 강의에 공유하는 모달
   ======================================================================== */

.template-share__overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  animation: tplShareFade 160ms ease-out;
}

@keyframes tplShareFade {
  from { opacity: 0; }
  to   { opacity: 1; }
}

.template-share__dialog {
  width: 100%;
  max-width: 720px;
  max-height: min(86vh, 760px);
  background: #fff;
  border-radius: var(--radius-xl, 16px);
  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.18), 0 6px 12px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  font-family: var(--font-sans);
  animation: tplShareSlide 180ms cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes tplShareSlide {
  from { opacity: 0; transform: translateY(8px); }
  to   { opacity: 1; transform: translateY(0); }
}

.template-share__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px 16px;
  border-bottom: 1px solid var(--fg-line);
}

.template-share__title {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: var(--fg-text-basic);
}

.template-share__close {
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  background: transparent;
  border: 0;
  border-radius: 8px;
  color: var(--fg-text-gray);
  cursor: pointer;
  transition: var(--transition-fast);
}

.template-share__close:hover:not(:disabled) {
  background: rgba(0, 0, 0, 0.04);
  color: var(--fg-text-basic);
}

.template-share__close:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.template-share__body {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px 24px;
  overflow: hidden;
}

.template-share__class-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.template-share__class-label {
  flex-shrink: 0;
  font-size: 13px;
  font-weight: 600;
  color: var(--fg-text-basic);
}

.template-share__class-select {
  flex: 1 1;
  min-width: 0;
  padding: 8px 12px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 10px;
  font-family: inherit;
  font-size: 14px;
  color: var(--fg-text-basic);
  cursor: pointer;
}

.template-share__class-select:focus {
  outline: none;
  border-color: var(--fg-button);
  box-shadow: 0 0 0 3px rgba(86, 60, 240, 0.12);
}

.template-share__tabs {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  border-bottom: 1px solid var(--fg-line);
  padding-bottom: 8px;
}

.template-share__tab {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background: transparent;
  border: 0;
  border-radius: 8px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  color: var(--fg-text-gray);
  cursor: pointer;
  transition: var(--transition-fast);
}

.template-share__tab:hover {
  background: rgba(0, 0, 0, 0.04);
  color: var(--fg-text-basic);
}

.template-share__tab--active {
  background: var(--fg-button);
  color: #fff;
}

.template-share__tab-count {
  padding: 1px 7px;
  background: rgba(255, 255, 255, 0.25);
  color: inherit;
  font-size: 11px;
  font-weight: 700;
  border-radius: 999px;
  line-height: 16px;
}

.template-share__tab:not(.template-share__tab--active) .template-share__tab-count {
  background: var(--fg-bg-content);
  color: var(--fg-text-gray);
}

.template-share__list {
  list-style: none;
  margin: 0;
  padding: 4px 2px 8px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  overflow-y: auto;
  flex: 1 1;
  min-height: 0;
}

.template-share__empty {
  padding: 32px 16px;
  text-align: center;
  font-size: 13px;
  color: var(--fg-text-gray);
}

.template-share__empty p {
  margin: 0;
}

.template-share__item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
  padding: 12px 14px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 10px;
  text-align: left;
  font-family: inherit;
  cursor: pointer;
  transition: var(--transition-fast);
}

.template-share__item:hover {
  border-color: var(--fg-button);
  background: var(--fg-bg-litepp, #f7f5ff);
}

.template-share__item--checked {
  border-color: var(--fg-button);
  background: var(--fg-bg-litepp, #f7f5ff);
}

.template-share__check {
  flex: 0 0 18px;
  width: 18px;
  height: 18px;
  border-radius: 4px;
  background: #fff;
  border: 1.5px solid var(--fg-line);
  display: grid;
  place-items: center;
  margin-top: 2px;
  transition: var(--transition-fast);
}

.template-share__check--on {
  background: var(--fg-button);
  border-color: var(--fg-button);
}

.template-share__item-text {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.template-share__item-title {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: var(--fg-text-basic);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.template-share__item-desc {
  margin: 0;
  font-size: 12px;
  color: var(--fg-text-gray);
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.template-share__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 24px 18px;
  border-top: 1px solid var(--fg-line);
}

.template-share__count {
  font-size: 13px;
  color: var(--fg-text-gray);
}

.template-share__count b {
  color: var(--fg-text-basic);
  font-weight: 700;
}

.template-share__actions {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.template-share__btn {
  padding: 9px 18px;
  border-radius: 10px;
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  border: 1px solid transparent;
  transition: var(--transition-fast);
}

.template-share__btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.template-share__btn--secondary {
  background: #fff;
  border-color: var(--fg-line);
  color: var(--fg-text-basic);
}

.template-share__btn--secondary:hover:not(:disabled) {
  background: var(--fg-bg-content);
  border-color: var(--fg-text-gray);
}

.template-share__btn--primary {
  background: var(--fg-button);
  color: #fff;
}

.template-share__btn--primary:hover:not(:disabled) {
  filter: brightness(1.06);
  box-shadow: 0 4px 8px rgba(86, 60, 240, 0.25);
}

/* ========================================================================
   모바일 (≤720px) — 공유공간(템플릿).
   사이드바는 내비가 없어 그냥 숨김(지식베이스와 동일). 하위 이동은 글로벌 헤더 드로어가 담당.
   공유 셸(.prompt__*, .prompt-list__*)은 .template-page 로 스코프해 타 기능 영향 차단.
   ======================================================================== */
@media (max-width: 720px) {
  /* 레이아웃: 사이드바 숨김, 메인 풀폭, 여백 축소 */
  .template-page .prompt__layout {
    margin: 0 8px;
  }

  .template-page .prompt__sidebar {
    display: none;
  }

  .template-page .prompt__content {
    padding: 20px 14px;
    gap: 24px;
  }

  .template-page .prompt-intro__h1 {
    font-size: 22px;
    line-height: 32px;
  }

  /* 카테고리 탭: 가로 스크롤(넘치면 스와이프) */
  .template-page .tpl-list__topbar {
    margin-top: 16px;
  }

  .template-page .tpl-list__tabs {
    overflow-x: auto;
    scrollbar-width: none;
  }

  .template-page .tpl-list__tabs::-webkit-scrollbar {
    display: none;
  }

  /* 검색/정렬: 검색이 줄을 가득 채우도록 */
  .template-page .tpl-list__filter-right {
    width: 100%;
    flex-wrap: wrap;
  }

  .template-page .prompt-list__search {
    flex: 1 1;
    width: auto;
    min-width: 0;
  }

  /* 카드 그리드 → 1열 (minmax(0,1fr) 로 긴 콘텐츠 오버플로 방지) */
  .template-page .tpl-list__grid {
    grid-template-columns: minmax(0, 1fr);
    gap: 12px;
  }

  /* 미리보기 패널: 화면 가득 차는 시트로 (데스크톱 760px → 풀폭) */
  .tpl-preview {
    width: 100vw;
    max-width: 100vw;
    border-top-right-radius: 0;
  }
}

`, "",{"version":3,"sources":["webpack://./src/css/Template.css"],"names":[],"mappings":"AAAA;;6EAE6E;;AAE7E,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,oCAAoC;EACpC,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;EACf,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;EAC5B,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,uBAAuB;EACvB,SAAS;EACT,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,WAAW;EACX,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;EAC3B,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,SAAO;EACP,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;EAC3B,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,MAAM;EACN,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA,wBAAwB;AACxB;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA,uDAAuD;AACvD;EACE,eAAe;EACf,gFAAgF;AAClF;;AAEA;EACE,yCAAyC;EACzC,2DAA2D;AAC7D;;AAEA;EACE,yCAAyC;EACzC,uDAAuD;AACzD;;AAEA;EACE,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA,yEAAyE;AACzE;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,UAAU;EACV,oBAAoB;EACpB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,eAAe;EACf,gCAAgC;EAChC,6BAA6B;EAC7B,yCAAyC;EACzC,2BAA2B;EAC3B,6DAA6D;EAC7D,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,oBAAoB;EACpB,4BAA4B;EAC5B,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,gCAAgC;EAChC,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,qCAAqC;EACrC,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,qCAAqC;EACrC,gCAAgC;EAChC,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,+GAA+G;EAC/G,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,qCAAqC;EACrC,gCAAgC;EAChC,qBAAqB;EACrB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,qCAAqC;EACrC,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,6BAA6B;AAC7B;;EAEE,UAAU;AACZ;;AAEA;;EAEE,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;;6EAE6E;;AAE7E;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,kCAAkC;EAClC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;EAChB,qCAAqC;EACrC,2EAA2E;EAC3E,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,6BAA6B;EAC7B,4DAA4D;AAC9D;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,uCAAuC;AACzC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,SAAO;EACP,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,6CAA6C;AAC/C;;AAEA;;;;6EAI6E;AAC7E;EACE,gCAAgC;EAChC;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA,6BAA6B;EAC7B;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA,0BAA0B;EAC1B;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,SAAO;IACP,WAAW;IACX,YAAY;EACd;;EAEA,gDAAgD;EAChD;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA,4CAA4C;EAC5C;IACE,YAAY;IACZ,gBAAgB;IAChB,0BAA0B;EAC5B;AACF","sourcesContent":["/* ========================================================================\n   Template — 글로벌 템플릿 (Figma 2001:12597)\n   ======================================================================== */\n\n/* 카테고리 탭 + 템플릿 공유 버튼 */\n.tpl-list__topbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  margin-top: 24px;\n}\n\n.tpl-list__tabs {\n  display: flex;\n  align-items: center;\n}\n\n.tpl-list__tab {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 10px;\n  background: transparent;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n  white-space: nowrap;\n  transition: var(--transition-fast);\n}\n\n.tpl-list__tab:hover {\n  color: var(--fg-side-hover);\n}\n\n.tpl-list__tab--active {\n  border-bottom-color: var(--fg-text-basic);\n}\n\n.tpl-list__tab-count {\n  font-size: 13px;\n  font-weight: 400;\n  color: var(--fg-text-gray);\n}\n\n.tpl-list__share-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  min-height: 42px;\n  padding: 6px 12px;\n  background: var(--fg-button);\n  border: 0;\n  border-radius: 12px;\n  color: #fff;\n  font-family: inherit;\n  font-size: 16px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.tpl-list__share-btn:hover {\n  background: var(--fg-button-hover);\n}\n\n/* 폴더 필터 (Figma 858:18362 — 공유 종목 체크박스 스타일) */\n.tpl-list__folders {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin: 12px 0 4px;\n}\n\n.tpl-list__folders-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n  white-space: nowrap;\n  margin-right: 8px;\n}\n\n.tpl-list__folders-items {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.tpl-list__folder-cb {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 0;\n  background: transparent;\n  border: 0;\n  font-family: inherit;\n  cursor: pointer;\n}\n\n.tpl-list__folder-cb-box {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  border-radius: 4px;\n  background: var(--fg-checkbox-off);\n  color: #fff;\n  flex-shrink: 0;\n  transition: var(--transition-fast);\n}\n\n.tpl-list__folder-cb-box--on {\n  background: var(--fg-side-hover);\n}\n\n.tpl-list__folder-cb-label {\n  font-size: 12px;\n  font-weight: 400;\n  color: var(--fg-text-basic);\n  white-space: nowrap;\n}\n\n.tpl-list__folder-cb-count {\n  font-size: 12px;\n  font-weight: 400;\n  color: var(--fg-text-gray);\n}\n\n/* 필터 행 (Figma 2001:12639) */\n.tpl-list__filter-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  margin-top: 12px;\n  padding: 9px 0;\n}\n\n.tpl-list__filter-left {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.tpl-list__filter-icon {\n  display: inline-flex;\n  width: 24px;\n  height: 24px;\n  color: var(--fg-text-basic);\n  margin-right: 8px;\n}\n\n.tpl-list__filter-cb {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  cursor: pointer;\n  user-select: none;\n}\n\n.tpl-list__filter-cb-label {\n  font-size: 14px;\n  color: var(--fg-text-basic);\n  white-space: nowrap;\n}\n\n.tpl-list__filter-cb-count {\n  font-size: 14px;\n  color: var(--fg-text-gray);\n  margin-left: 4px;\n}\n\n.tpl-list__cb {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  border: 1px solid var(--fg-line);\n  border-radius: 4px;\n  background: #fff;\n  color: #fff;\n  flex-shrink: 0;\n  transition: var(--transition-fast);\n}\n\n.tpl-list__cb--on {\n  background: var(--fg-button);\n  border-color: var(--fg-button);\n}\n\n.tpl-list__filter-right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* 카드 그리드 (Figma 2001:12661 — 4열, gap 20px) */\n.tpl-list__grid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 20px;\n  width: 100%;\n  margin-top: 12px;\n}\n\n/* 단일 템플릿 카드 (Figma 2001:12662 — List - Box full 369x198) */\n.tpl-list__card {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 16px 20px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 12px;\n  min-height: 198px;\n  transition: var(--transition-fast);\n}\n\n.tpl-list__card:hover {\n  border-color: var(--fg-button);\n  box-shadow: var(--shadow-sm);\n}\n\n.tpl-list__card-head {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  width: 100%;\n}\n\n.tpl-list__card-tag {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  align-self: flex-start;\n  padding: 6px 10px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 400;\n  color: var(--fg-text-basic);\n  white-space: nowrap;\n  line-height: 1;\n}\n\n.tpl-list__card-title {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 28px;\n  color: var(--fg-text-basic);\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.tpl-list__card-meta {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 13px;\n  color: var(--fg-text-gray);\n}\n\n.tpl-list__card-user {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n}\n\n.tpl-list__card-meta-divider {\n  display: inline-block;\n  width: 1px;\n  height: 14px;\n  background: var(--fg-line);\n}\n\n.tpl-list__card-desc {\n  flex: 1;\n  margin: 0;\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 24px;\n  color: var(--fg-text-basic);\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.tpl-list__card-actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0;\n  margin-top: auto;\n}\n\n.tpl-list__card-icon-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  padding: 2px;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  color: var(--fg-text-gray);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.tpl-list__card-icon-btn:hover {\n  background: var(--fg-bg-card);\n  color: var(--fg-text-basic);\n}\n\n.tpl-list__card-icon-btn--liked {\n  color: #ff1500;\n}\n\n.tpl-list__card-icon-btn--liked:hover {\n  color: #ff1500;\n  background: rgba(255, 21, 0, 0.08);\n}\n\n.tpl-list__card-icon-btn--danger {\n  color: #ea5440;\n}\n\n.tpl-list__card-icon-btn--danger:hover {\n  background: rgba(234, 84, 64, 0.08);\n}\n\n.tpl-list__card-likes {\n  font-size: 12px;\n  color: #ff1500;\n  margin-right: 4px;\n}\n\n/* 반응형: 1280px 이하에서 3열 */\n@media (max-width: 1280px) {\n  .tpl-list__grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n/* ──────────────── 카드 클릭 가능 / 선택 상태 ──────────────── */\n.tpl-list__card {\n  cursor: pointer;\n  transition: border-color 160ms ease, box-shadow 160ms ease, transform 120ms ease;\n}\n\n.tpl-list__card:hover {\n  border-color: var(--primary-300, #c7b8ff);\n  box-shadow: var(--shadow-sm, 0 1px 3px rgba(0, 0, 0, 0.06));\n}\n\n.tpl-list__card--selected {\n  border-color: var(--primary-500, #7c5cff);\n  box-shadow: 0 0 0 2px var(--primary-100, #ece6ff) inset;\n}\n\n.tpl-list__card:focus-visible {\n  outline: 2px solid var(--primary-500, #7c5cff);\n  outline-offset: 2px;\n}\n\n/* ──────────────── 우측 슬라이드 미리보기 패널 (Figma 2047:12694) ──────────────── */\n.tpl-preview__backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 17, 28, 0.32);\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 220ms ease;\n  z-index: 90;\n}\n\n.tpl-preview__backdrop--open {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.tpl-preview {\n  position: fixed;\n  top: 0;\n  right: 0;\n  height: 100vh;\n  width: 760px;\n  max-width: 96vw;\n  background: var(--fg-bg-toolbox);\n  border-top-right-radius: 16px;\n  box-shadow: -4px 0 7px rgba(0, 0, 0, 0.2);\n  transform: translateX(100%);\n  transition: transform 280ms cubic-bezier(0.22, 0.61, 0.36, 1);\n  display: flex;\n  flex-direction: column;\n  font-family: var(--font-sans);\n  z-index: 100;\n  overflow: hidden;\n}\n\n.tpl-preview--open {\n  transform: translateX(0);\n}\n\n.tpl-preview__header {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 20px 20px 0;\n  flex-shrink: 0;\n}\n\n.tpl-preview__title {\n  flex: 1;\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 28px;\n  color: #ffffff;\n  word-break: break-word;\n}\n\n.tpl-preview__copy {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  height: 32px;\n  padding: 5px 7px 7px;\n  background: var(--fg-button);\n  border: 0;\n  border-radius: 4px;\n  color: #ffffff;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1;\n  cursor: pointer;\n  transition: background 120ms ease;\n  flex-shrink: 0;\n}\n\n.tpl-preview__copy:hover:not(:disabled) {\n  background: var(--fg-button-hover);\n}\n\n.tpl-preview__copy:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.tpl-preview__close {\n  width: 32px;\n  height: 32px;\n  display: grid;\n  place-items: center;\n  padding: 2px;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  color: #ffffff;\n  cursor: pointer;\n  transition: background 120ms ease;\n  flex-shrink: 0;\n}\n\n.tpl-preview__close:hover {\n  background: rgba(255, 255, 255, 0.10);\n}\n\n.tpl-preview__body {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.tpl-preview__tags-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n}\n\n.tpl-preview__tag {\n  display: inline-flex;\n  align-items: center;\n  padding: 6px 10px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 400;\n  color: var(--fg-text-basic);\n  white-space: nowrap;\n  line-height: 1;\n}\n\n.tpl-preview__meta {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n  color: var(--fg-text-menu);\n  margin-top: -8px;\n}\n\n.tpl-preview__meta-divider {\n  width: 1px;\n  height: 12px;\n  background: rgba(255, 255, 255, 0.20);\n}\n\n.tpl-preview__desc-box {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 16px;\n  border: 1px solid var(--fg-line);\n  border-radius: 8px;\n  background: transparent;\n}\n\n.tpl-preview__desc-box-title {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 24px;\n  color: #ffffff;\n}\n\n.tpl-preview__desc-box-text {\n  margin: 0;\n  font-size: 15px;\n  line-height: 24px;\n  color: #ffffff;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.tpl-preview__section {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.tpl-preview__section-title {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 700;\n  color: #ffffff;\n}\n\n.tpl-preview__section-text {\n  margin: 0;\n  padding: 8px 12px;\n  background: var(--fg-bg-toolbox-elev);\n  border: 1px solid var(--fg-line);\n  border-radius: 8px;\n  font-size: 16px;\n  line-height: 26px;\n  color: #ffffff;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.tpl-preview__section-pre {\n  margin: 0;\n  padding: 8px 12px;\n  background: var(--fg-bg-toolbox-elev);\n  border: 1px solid var(--fg-line);\n  border-radius: 8px;\n  font-family: inherit;\n  font-size: 16px;\n  line-height: 26px;\n  color: #ffffff;\n  white-space: pre-wrap;\n  word-break: break-word;\n  max-height: 320px;\n  overflow-y: auto;\n}\n\n.tpl-preview__section-pre--code {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  font-size: 13px;\n  line-height: 1.6;\n  max-height: 480px;\n}\n\n.tpl-preview__bullets {\n  list-style: disc inside;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  font-size: 15px;\n  line-height: 24px;\n  color: #ffffff;\n}\n\n.tpl-preview__chips {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.tpl-preview__chip {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 10px;\n  background: var(--fg-bg-toolbox-elev);\n  border: 1px solid var(--fg-line);\n  border-radius: 9999px;\n  font-size: 12px;\n  color: #ffffff;\n}\n\n.tpl-preview__meta-list {\n  list-style: none;\n  margin: 0;\n  padding: 12px 16px;\n  background: var(--fg-bg-toolbox-elev);\n  border: 1px solid var(--fg-line);\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  font-size: 14px;\n}\n\n.tpl-preview__meta-list li {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n}\n\n.tpl-preview__meta-list li span {\n  color: var(--fg-text-menu);\n}\n\n.tpl-preview__meta-list li b {\n  font-weight: 600;\n  color: #ffffff;\n}\n\n.tpl-preview__loading {\n  margin: 0;\n  font-size: 13px;\n  color: var(--fg-text-menu);\n  text-align: center;\n}\n\n.tpl-preview__node-list {\n  list-style: none;\n  margin: 0;\n  padding: 12px;\n  background: var(--fg-bg-toolbox-elev);\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.tpl-preview__node-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 10px 12px;\n  background: var(--fg-bg-toolbox);\n  border: 1px solid var(--fg-line);\n  border-radius: 8px;\n}\n\n.tpl-preview__node-info {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.tpl-preview__node-name {\n  font-size: 14px;\n  font-weight: 600;\n  color: #ffffff;\n  word-break: break-word;\n}\n\n.tpl-preview__node-desc {\n  font-size: 12px;\n  color: var(--fg-text-menu);\n  line-height: 1.5;\n  word-break: break-word;\n}\n\n/* 다크 패널 내부 스크롤바 (선택적 스타일링) */\n.tpl-preview__body::-webkit-scrollbar,\n.tpl-preview__section-pre::-webkit-scrollbar {\n  width: 8px;\n}\n\n.tpl-preview__body::-webkit-scrollbar-thumb,\n.tpl-preview__section-pre::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.15);\n  border-radius: 4px;\n}\n\n.tpl-preview__body::-webkit-scrollbar-thumb:hover,\n.tpl-preview__section-pre::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.25);\n}\n\n/* ========================================================================\n   ShareTemplateModal — 내 템플릿을 강의에 공유하는 모달\n   ======================================================================== */\n\n.template-share__overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  background: rgba(15, 23, 42, 0.55);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  animation: tplShareFade 160ms ease-out;\n}\n\n@keyframes tplShareFade {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n\n.template-share__dialog {\n  width: 100%;\n  max-width: 720px;\n  max-height: min(86vh, 760px);\n  background: #fff;\n  border-radius: var(--radius-xl, 16px);\n  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.18), 0 6px 12px rgba(0, 0, 0, 0.06);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  font-family: var(--font-sans);\n  animation: tplShareSlide 180ms cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n@keyframes tplShareSlide {\n  from { opacity: 0; transform: translateY(8px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n.template-share__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 24px 16px;\n  border-bottom: 1px solid var(--fg-line);\n}\n\n.template-share__title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--fg-text-basic);\n}\n\n.template-share__close {\n  width: 32px;\n  height: 32px;\n  display: grid;\n  place-items: center;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  color: var(--fg-text-gray);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.template-share__close:hover:not(:disabled) {\n  background: rgba(0, 0, 0, 0.04);\n  color: var(--fg-text-basic);\n}\n\n.template-share__close:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.template-share__body {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 16px 24px;\n  overflow: hidden;\n}\n\n.template-share__class-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.template-share__class-label {\n  flex-shrink: 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n}\n\n.template-share__class-select {\n  flex: 1;\n  min-width: 0;\n  padding: 8px 12px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 10px;\n  font-family: inherit;\n  font-size: 14px;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n}\n\n.template-share__class-select:focus {\n  outline: none;\n  border-color: var(--fg-button);\n  box-shadow: 0 0 0 3px rgba(86, 60, 240, 0.12);\n}\n\n.template-share__tabs {\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n  border-bottom: 1px solid var(--fg-line);\n  padding-bottom: 8px;\n}\n\n.template-share__tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 12px;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--fg-text-gray);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.template-share__tab:hover {\n  background: rgba(0, 0, 0, 0.04);\n  color: var(--fg-text-basic);\n}\n\n.template-share__tab--active {\n  background: var(--fg-button);\n  color: #fff;\n}\n\n.template-share__tab-count {\n  padding: 1px 7px;\n  background: rgba(255, 255, 255, 0.25);\n  color: inherit;\n  font-size: 11px;\n  font-weight: 700;\n  border-radius: 999px;\n  line-height: 16px;\n}\n\n.template-share__tab:not(.template-share__tab--active) .template-share__tab-count {\n  background: var(--fg-bg-content);\n  color: var(--fg-text-gray);\n}\n\n.template-share__list {\n  list-style: none;\n  margin: 0;\n  padding: 4px 2px 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  overflow-y: auto;\n  flex: 1;\n  min-height: 0;\n}\n\n.template-share__empty {\n  padding: 32px 16px;\n  text-align: center;\n  font-size: 13px;\n  color: var(--fg-text-gray);\n}\n\n.template-share__empty p {\n  margin: 0;\n}\n\n.template-share__item {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  width: 100%;\n  padding: 12px 14px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 10px;\n  text-align: left;\n  font-family: inherit;\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.template-share__item:hover {\n  border-color: var(--fg-button);\n  background: var(--fg-bg-litepp, #f7f5ff);\n}\n\n.template-share__item--checked {\n  border-color: var(--fg-button);\n  background: var(--fg-bg-litepp, #f7f5ff);\n}\n\n.template-share__check {\n  flex: 0 0 18px;\n  width: 18px;\n  height: 18px;\n  border-radius: 4px;\n  background: #fff;\n  border: 1.5px solid var(--fg-line);\n  display: grid;\n  place-items: center;\n  margin-top: 2px;\n  transition: var(--transition-fast);\n}\n\n.template-share__check--on {\n  background: var(--fg-button);\n  border-color: var(--fg-button);\n}\n\n.template-share__item-text {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.template-share__item-title {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.template-share__item-desc {\n  margin: 0;\n  font-size: 12px;\n  color: var(--fg-text-gray);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n\n.template-share__footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 14px 24px 18px;\n  border-top: 1px solid var(--fg-line);\n}\n\n.template-share__count {\n  font-size: 13px;\n  color: var(--fg-text-gray);\n}\n\n.template-share__count b {\n  color: var(--fg-text-basic);\n  font-weight: 700;\n}\n\n.template-share__actions {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.template-share__btn {\n  padding: 9px 18px;\n  border-radius: 10px;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  border: 1px solid transparent;\n  transition: var(--transition-fast);\n}\n\n.template-share__btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.template-share__btn--secondary {\n  background: #fff;\n  border-color: var(--fg-line);\n  color: var(--fg-text-basic);\n}\n\n.template-share__btn--secondary:hover:not(:disabled) {\n  background: var(--fg-bg-content);\n  border-color: var(--fg-text-gray);\n}\n\n.template-share__btn--primary {\n  background: var(--fg-button);\n  color: #fff;\n}\n\n.template-share__btn--primary:hover:not(:disabled) {\n  filter: brightness(1.06);\n  box-shadow: 0 4px 8px rgba(86, 60, 240, 0.25);\n}\n\n/* ========================================================================\n   모바일 (≤720px) — 공유공간(템플릿).\n   사이드바는 내비가 없어 그냥 숨김(지식베이스와 동일). 하위 이동은 글로벌 헤더 드로어가 담당.\n   공유 셸(.prompt__*, .prompt-list__*)은 .template-page 로 스코프해 타 기능 영향 차단.\n   ======================================================================== */\n@media (max-width: 720px) {\n  /* 레이아웃: 사이드바 숨김, 메인 풀폭, 여백 축소 */\n  .template-page .prompt__layout {\n    margin: 0 8px;\n  }\n\n  .template-page .prompt__sidebar {\n    display: none;\n  }\n\n  .template-page .prompt__content {\n    padding: 20px 14px;\n    gap: 24px;\n  }\n\n  .template-page .prompt-intro__h1 {\n    font-size: 22px;\n    line-height: 32px;\n  }\n\n  /* 카테고리 탭: 가로 스크롤(넘치면 스와이프) */\n  .template-page .tpl-list__topbar {\n    margin-top: 16px;\n  }\n\n  .template-page .tpl-list__tabs {\n    overflow-x: auto;\n    scrollbar-width: none;\n  }\n\n  .template-page .tpl-list__tabs::-webkit-scrollbar {\n    display: none;\n  }\n\n  /* 검색/정렬: 검색이 줄을 가득 채우도록 */\n  .template-page .tpl-list__filter-right {\n    width: 100%;\n    flex-wrap: wrap;\n  }\n\n  .template-page .prompt-list__search {\n    flex: 1;\n    width: auto;\n    min-width: 0;\n  }\n\n  /* 카드 그리드 → 1열 (minmax(0,1fr) 로 긴 콘텐츠 오버플로 방지) */\n  .template-page .tpl-list__grid {\n    grid-template-columns: minmax(0, 1fr);\n    gap: 12px;\n  }\n\n  /* 미리보기 패널: 화면 가득 차는 시트로 (데스크톱 760px → 풀폭) */\n  .tpl-preview {\n    width: 100vw;\n    max-width: 100vw;\n    border-top-right-radius: 0;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
